/**
* This enum tells if a SaniFair voucher in the credit
*             is allowed for paying within a specific order.
*             
*             Notice, that there exist other reasons why a SaniFair voucher
*             is not accepted, but those happen already before the voucher
*             could be added to the user's credit.
*             See <see cref="T:Iovent.Model.Vouchers.SaniFair.SaniFairResult" /> for those problems.
*/
export enum SaniFairEligibility { 
	/** The SaniFair voucher is accepted for the order. */
	Allowed = "Allowed", 
	/**
	* The SaniFair voucher can not be used for this order,
	*             because the minimal order price was not reached
	*             (see <see cref="P:Iovent.Model.Devices.Config.Payment.SaniFairConfig.MinOrderCents" />).
	*/
	MinOrderPrice = "MinOrderPrice"
}
